import React, { useEffect, useState } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";


function Banner() {

  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);
  const [isWaiting, setIsWaiting] = useState(false);

  const points = [
    "Intelligent Business Process Automation",
    "Advanced Data Analytics & Machine Learning",
    "Custom AI Chatbot Development Services",
    "Smart Document Processing & Analysis",
    "Predictive Analytics for Business Growth",
    "AI-Driven Marketing Automation Tools",
    "Intelligent Workflow Optimization Systems"
  ];

  useEffect(() => {
    if (isWaiting) return;

    const currentPoint = points[currentIndex];

    const timer = setTimeout(() => {
      if (isTyping) {
        if (charIndex < currentPoint.length) {
          setDisplayText(currentPoint.substring(0, charIndex + 1));
          setCharIndex(charIndex + 1);
        } else {
          setIsWaiting(true);
          setTimeout(() => {
            setIsWaiting(false);
            setIsTyping(false);
          }, 2000);
        }
      } else {
        if (charIndex > 0) {
          setDisplayText(currentPoint.substring(0, charIndex - 1));
          setCharIndex(charIndex - 1);
        } else {
          setIsTyping(true);
          setCurrentIndex((currentIndex + 1) % points.length);
        }
      }
    }, isTyping ? 80 : 50);

    return () => clearTimeout(timer);
  }, [charIndex, currentIndex, isTyping, isWaiting, points]);
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      <section className="home-banner1" style={{ paddingTop: '143.984px', overflowX: "hidden" }} >
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex flex-wrap align-items-center" data-aos="fade-right">
              <div className="banner-content">
                <h2 className="banner-title2 banner-title " data-aos="fade-right" data-aos-delay="200">Codenix Infotech</h2>
                <div className="typing-container">
                  {/* <span className="typing-prefix">AI-based company providing </span> */}
                  <span className="typing-text ">{displayText}</span>
                  <span className="cursor"></span>
                </div>
                <div className="banner-text">
                  <p className='w-lg-50' data-aos="fade-right" data-aos-delay="500">
                    Welcome to Codenix Infotech, where AI automation meets innovation.
                    We specialize in delivering intelligent automation solutions, AI-driven consulting, and digital transformation services to empower businesses to scale, optimize, and thrive in today’s rapidly evolving market.

                  </p>
                </div>
                <div className="banner-button" data-aos="fade-in" data-aos-delay="600">
                  <a href="/about" className="button-round">
                    Learn More
                  </a>
                  {/* <a
              href="contact.html"
              className="outline-round outline-round-white"
            >
              Follow Us
            </a> */}
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4   d-flex mt-5 pt-3 flex-wrap align-items-end d-none d-lg-block d-md-block" data-aos="fade-in" data-aos-delay="400">
              <figure className="banner-img p-5 mb-5 px-1 py-4">
                {/* <img src="assets/images/banner-img1.png" alt="" /> */}
                {/* <img src="assets/images/bannerda.png" alt=""  /> */}
                <img src="assets/banner/center.png" alt="" />
                <img src="assets/banner/one.png" alt="" />
                <img src="assets/banner/two.png" alt="" />
                <img src="assets/banner/four.png" alt="" />
                <img src="assets/banner/eight.png" alt="" />
                <img src="assets/banner/seven.png" alt="" />
                <img src="assets/banner/six.png" alt="" />
              </figure>
            </div>
          </div>
        </div>
        <div
          className="banner-pattern"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        />
      </section>

    </div>
  )
}

export default Banner

